// src/components/Pimgy/PimgyHome.js
import React, { useState, useEffect } from "react";
import { Routes, Route, NavLink, useLocation, useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { API_BASE_URL } from '../../config';
import NewApplication from "./NewApplication";
import ReceivePayments from "./ReceivePayments";
import PigmyWithdraw from "./PigmyWithdraw";
import CloseApplication from "./CloseApplication";
import TransactionHistory from "./TransactionHistory";
import IndividualTransactionHistory from "./IndividualTransactionHistory";
const PimgyHome = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const normalizedPath = location.pathname.replace(/\/+$/, "");
  const showSidebar = normalizedPath === "/pigmy-collection";
  const [showBalancePanel, setShowBalancePanel] = useState(false);
  const [balanceData, setBalanceData] = useState(null);
  const [loadingBalance, setLoadingBalance] = useState(false);

  // Fetch balance data
  const fetchBalanceData = async () => {
    setLoadingBalance(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/pimgy/balance-summary`);
      if (response.ok) {
        const data = await response.json();
        setBalanceData(data);
      }
    } catch (error) {
      console.error('Error fetching balance data:', error);
    } finally {
      setLoadingBalance(false);
    }
  };

  // Handle Control+Q toggle
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.ctrlKey && e.key === 'q') {
        e.preventDefault();
        setShowBalancePanel(prev => {
          const newState = !prev;
          if (newState) {
            fetchBalanceData();
          }
          return newState;
        });
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const formatCurrency = (amount) => {
    const value = Number(amount || 0);
    return `₹ ${value.toFixed(2)}`;
  };
  return (
    <div className={`dashboard-container${showSidebar ? "" : " no-sidebar"}`}>
      <style>
        {`
          /* General Page Styling */
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          html, body {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Poppins', sans-serif;
            background: linear-gradient(135deg, #f3eae2, #e4d5c7);
            height: auto;
            min-height: 100vh;
            overflow-y: auto;
          }

          .dashboard-container {
            display: flex;
            width: 100%;
            max-width: 100%;
            min-height: 100vh;
            height: auto;
            background-color: white;
            border-radius: 0;
            box-shadow: none;
            overflow-y: auto;
          }

          .no-sidebar {
            width: 100%;
            max-width: 100%;
          }

          .sidebar {
            width: 280px;
            background: #2c3e50;
            color: white;
            padding: 20px;
            display: flex;
            flex-direction: column;
          }

          .sidebar nav ul {
            list-style: none;
            padding: 0;
          }

          .sidebar h2 {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            padding-bottom: 15px;
            border-bottom: 2px solid #34495e;
          }

          .sidebar nav ul li {
            margin: 15px 0;
          }

          .sidebar nav ul li a {
            text-decoration: none;
            color: white;
            font-size: 16px;
            font-weight: 500;
            display: flex;
            align-items: center;
            padding: 10px;
            border-radius: 6px;
            transition: all 0.3s ease-in-out;
          }

          .sidebar nav ul li a:hover,
          .sidebar nav ul li a.active-link {
            background-color: #34495e;
            transform: scale(1.05);
          }

          .sidebar nav ul li a i {
            margin-right: 10px;
          }

          .back-button {
            width: 100%;
            padding: 10px;
            background: #c0392b;
            color: white;
            font-size: 16px;
            font-weight: bold;
            border: none;
            cursor: pointer;
            border-radius: 6px;
            transition: all 0.3s ease-in-out;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .back-button i {
            margin-right: 8px;
          }

          .back-button:hover {
            background: #a93226;
            transform: scale(1.05);
          }

          .content {
            flex: 1;
            padding: 30px;
            background: #fdfdfd;
            text-align: center;
            overflow-y: auto;
          }

          .content--full {
            padding: 0;
            background: transparent;
            text-align: left;
          }

          .content-back-container {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 20px;
          }

          .content-back-button {
            padding: 10px 18px;
            background: #2c3e50;
            color: white;
            border: none;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
          }

          .content-back-button i {
            margin-right: 0;
          }

          .content-back-button:hover {
            background: #34495e;
            transform: translateY(-1px);
          }

          .content h2 {
            font-size: 24px;
            margin-bottom: 15px;
            color: #2c3e50;
          }

          .content p {
            font-size: 16px;
            color: #555;
          }

          @media screen and (max-width: 768px) {
            .dashboard-container {
              flex-direction: column;
              height: auto;
            }

            .sidebar {
              width: 100%;
              padding: 15px;
              text-align: center;
            }

            .sidebar nav ul li {
              margin: 10px 0;
            }

            .back-button {
              width: 80%;
              margin: auto;
            }
          }

          /* Balance Panel Styles */
          .balance-panel {
            position: fixed;
            right: 0;
            top: 0;
            width: 350px;
            height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 30px 20px;
            box-shadow: -4px 0 15px rgba(0, 0, 0, 0.2);
            z-index: 1000;
            overflow-y: auto;
            transition: transform 0.3s ease-in-out;
          }

          .balance-panel.hidden {
            transform: translateX(100%);
          }

          .balance-panel-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            padding-bottom: 15px;
            border-bottom: 2px solid rgba(255, 255, 255, 0.3);
          }

          .balance-panel-header h2 {
            margin: 0;
            font-size: 24px;
            font-weight: 600;
          }

          .balance-panel-close {
            background: rgba(255, 255, 255, 0.2);
            border: none;
            color: white;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            transition: background 0.3s;
          }

          .balance-panel-close:hover {
            background: rgba(255, 255, 255, 0.3);
          }

          .balance-item {
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(10px);
            padding: 20px;
            margin-bottom: 15px;
            border-radius: 12px;
            border: 1px solid rgba(255, 255, 255, 0.2);
          }

          .balance-item-label {
            font-size: 14px;
            opacity: 0.9;
            margin-bottom: 8px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .balance-item-value {
            font-size: 28px;
            font-weight: 700;
            color: #fff;
          }

          .balance-item.total {
            background: rgba(255, 255, 255, 0.25);
            border: 2px solid rgba(255, 255, 255, 0.4);
          }

          .balance-item.total .balance-item-value {
            font-size: 32px;
          }

          .balance-loading {
            text-align: center;
            padding: 40px 20px;
            font-size: 16px;
            opacity: 0.9;
          }

          .balance-error {
            text-align: center;
            padding: 20px;
            background: rgba(255, 0, 0, 0.2);
            border-radius: 8px;
            margin-top: 20px;
          }

          .balance-hint {
            margin-top: 30px;
            padding-top: 20px;
            border-top: 1px solid rgba(255, 255, 255, 0.2);
            font-size: 12px;
            opacity: 0.8;
            text-align: center;
          }
        `}
      </style>

      {showSidebar && (
        <aside className="sidebar">
          <h2>Pigmy Collection</h2>
          <nav>
            <ul>
              <li>
                <NavLink to="new" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-file-alt"></i> New Application
                </NavLink>
              </li>
              <li>
                <NavLink to="receive-payments" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-money-check-alt"></i> Receive Payments
                </NavLink>
              </li>
              <li>
                <NavLink to="pigmy-withdraw" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-money-bill-wave"></i> Pigmy Withdraw
                </NavLink>
              </li>
              <li>
                <NavLink to="close-application" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-times-circle"></i> Close Application
                </NavLink>
              </li>
              <li>
                <NavLink to="transaction-history" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-history"></i> Transaction History
                </NavLink>
              </li>
              <li>
                <NavLink to="individual-history" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-user"></i> Individual Transaction History
                </NavLink>
              </li>
              <li>
                <button onClick={() => navigate("/admin-dashboard")} className="back-button">
                  <i className="fas fa-arrow-left"></i> Back
                </button>
              </li>
            </ul>
          </nav>
        </aside>
      )}
      {/* Balance Panel */}
      <div className={`balance-panel ${showBalancePanel ? '' : 'hidden'}`}>
        <div className="balance-panel-header">
          <h2>Pigmy Balance</h2>
          <button
            className="balance-panel-close"
            onClick={() => setShowBalancePanel(false)}
            title="Close (Ctrl+Q)"
          >
            ×
          </button>
        </div>
        {loadingBalance ? (
          <div className="balance-loading">Loading balance data...</div>
        ) : balanceData ? (
          <>
            <div className="balance-item">
              <div className="balance-item-label">Pigmy Credit</div>
              <div className="balance-item-value">{formatCurrency(balanceData.pigmyCredit)}</div>
            </div>
            <div className="balance-item">
              <div className="balance-item-label">Pigmy Debit</div>
              <div className="balance-item-value">{formatCurrency(balanceData.pigmyDebit)}</div>
            </div>
            <div className="balance-item total">
              <div className="balance-item-label">Pigmy Total Balance</div>
              <div className="balance-item-value">{formatCurrency(balanceData.pigmyTotalBalance)}</div>
            </div>
            <div className="balance-hint">
              Press Ctrl+Q to toggle this panel
            </div>
          </>
        ) : (
          <div className="balance-error">Failed to load balance data</div>
        )}
      </div>

      <main className={showSidebar ? "content" : "content content--full"}>
        {!showSidebar && (
          <div className="content-back-container">
            <button
              type="button"
              className="content-back-button"
              onClick={() => navigate("/pigmy-collection")}
            >
              <i className="fas fa-arrow-left"></i>
              Back to Pigmy Menu
            </button>
          </div>
        )}
        <Routes>
          <Route index element={
            <div>
              <h2>Welcome to the Pigmy Collection Section</h2>
              <p>Select an option from the menu to proceed.</p>
            </div>
          } />
          <Route path="new" element={<NewApplication />} />
          <Route path="receive-payments" element={<ReceivePayments />} />
          <Route path="pigmy-withdraw" element={<PigmyWithdraw />} />
          <Route path="close-application" element={<CloseApplication />} />
          <Route path="transaction-history" element={<TransactionHistory />} />
          <Route path="individual-history" element={<IndividualTransactionHistory />} />
          <Route path="*" element={
            <div>
              <h2>Welcome to the Pigmy Collection Section</h2>
              <p>Select an option from the menu to proceed.</p>
            </div>
          } />
        </Routes>
      </main>
    </div>
  );
};

export default PimgyHome;

